import { styled } from "@mui/material/styles";

// Components
import { Tab } from "@mui/material";

const styledName = "MonthTab";

export const StyledTab = styled(Tab, { name: styledName })({
  width: "20%",
  minWidth: "fit-content",
});
